module.exports = __webpack_public_path__ + "img/chart_plot.33a65637.webp";